'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchStreamIdIfNeeded = exports.isStreamIdLoading = exports.getLoadTimeForStreamId = exports.getStreamStatus = exports.LOAD_STREAM_NAME_SUCCESS = exports.LOAD_STREAM_NAME_REQUEST = exports.LOAD_STREAM_NAME_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('./user');

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_STREAM_NAME_FAIL = exports.LOAD_STREAM_NAME_FAIL = 'la/domain/video/LOAD_FAIL';
var LOAD_STREAM_NAME_REQUEST = exports.LOAD_STREAM_NAME_REQUEST = 'la/domain/video/LOAD_REQUEST';
var LOAD_STREAM_NAME_SUCCESS = exports.LOAD_STREAM_NAME_SUCCESS = 'la/domain/video/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('1s');

// reducer
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_STREAM_NAME_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_STREAM_NAME_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_STREAM_NAME_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends4.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.catalogId, time));
            loading = (0, _cloneDeep2.default)(state.loading);

            existing[action.meta.catalogId] = action.payload;
            loading = (0, _difference2.default)(loading, [action.meta.catalogId]);
            return (0, _extends4.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.video;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getStreamStatus = exports.getStreamStatus = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForStreamId = exports.getLoadTimeForStreamId = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isStreamIdLoading = exports.isStreamIdLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchStreamId = (0, _reselect.createSelector)([idSelector, getStreamStatus, getLoadTimeForStreamId, isStreamIdLoading], function (catalogId, streamId, loaded, loading) {
    if (!catalogId) return false;
    if (streamId) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var loadStreamId = function loadStreamId(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, _ref2, payload;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_STREAM_NAME_REQUEST
                            });
                            _context.next = 7;
                            return _api.Video.fetchStreamId({
                                authToken: authToken,
                                catalogId: catalogId,
                                deployment: deployment
                            });

                        case 7:
                            _ref2 = _context.sent;
                            payload = _ref2.payload;


                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: payload,
                                type: LOAD_STREAM_NAME_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_STREAM_NAME_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchStreamIdIfNeeded = exports.fetchStreamIdIfNeeded = function fetchStreamIdIfNeeded(catalogId) {
    return function (dispatch, getState) {
        if (shouldFetchStreamId(getState(), catalogId)) {
            return dispatch(loadStreamId(catalogId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/video.js
// module id = M8lj
// module chunks = 60